import { render } from "./App.vue?vue&type=template&id=2c1a5f6d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2c1a5f6d&lang=scss"

import exportComponent from "D:\\ddj\\ddj-java\\ddj-manager-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__